(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[20],{

/***/ 7121:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/media",
      function () {
        return __webpack_require__(1333);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ media; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./src/layouts/index.ts + 2 modules
var layouts = __webpack_require__(2039);
// EXTERNAL MODULE: ./src/layouts/pages/business/index.ts + 5 modules
var business = __webpack_require__(6291);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
;// CONCATENATED MODULE: ./src/views/business/media/sections/about.tsx




var AboutSection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(business/* AboutSectionLayout */.qv, {
        name: (0,utils.t)("pages.business.media.sections.about.name"),
        title: (0,utils.t)("pages.business.media.sections.about.title"),
        card1Props: {
            contents: {
                key: (0,utils.t)("pages.business.media.sections.contents.title1"),
                title: (0,utils.t)("pages.business.media.sections.contents.title1"),
                body: (0,utils.t)("pages.business.media.sections.contents.body1")
            },
            imgSrc: "/pages/business/media/sections/about/bg_1.png"
        },
        card2Props: {
            contents: {
                key: (0,utils.t)("pages.business.media.sections.contents.title2"),
                title: (0,utils.t)("pages.business.media.sections.contents.title2"),
                body: (0,utils.t)("pages.business.media.sections.contents.body2")
            },
            imgSrc: "/pages/business/media/sections/about/bg_2.png"
        }
    });
};
/* harmony default export */ var about = (AboutSection);

// EXTERNAL MODULE: ./src/views/business/index.ts + 3 modules
var views_business = __webpack_require__(7812);
;// CONCATENATED MODULE: ./src/views/business/media/sections/process.tsx




var ProcessSection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(business/* ProcessSectionLayout */.Qc, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* ProcessFeature */.z3, {
                index: "01",
                title: "이슈",
                iconUrl: "/pages/business/viral/sections/process/icon_1.png",
                contents: [
                    "신규 브랜드 및 신제품 런칭",
                    "프로모션 이벤트 실행",
                    "기업 홈페이지 및 쇼핑몰 홍보", 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* ProcessFeature */.z3, {
                index: "02",
                title: "기획",
                iconUrl: "/pages/business/viral/sections/process/icon_2.png",
                contents: [
                    "희망 노출 매체 설정",
                    "보도 희망 언론 설정 및 협의",
                    "언론 송출 기사 기획 및 생성",
                    "콘텐츠의 고객사 컨펌", 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* ProcessFeature */.z3, {
                index: "03",
                title: "진행",
                iconUrl: "/pages/business/viral/sections/process/icon_3.png",
                contents: [
                    "Presskit 언론사에 배포"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* ProcessFeature */.z3, {
                index: "04",
                title: "완료",
                iconUrl: "/pages/business/viral/sections/process/icon_4.png",
                contents: [
                    "기사 콘텐츠 송출",
                    "핵심 키워드 노출 확인",
                    "언론송출 효과 평가 및 피드백", 
                ]
            })
        ]
    });
};
/* harmony default export */ var process = (ProcessSection);

// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./src/layout/index.ts + 16 modules
var layout = __webpack_require__(7818);
;// CONCATENATED MODULE: ./src/views/business/media/sections/specialty.tsx





var SpecialtySection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "specialty",
        sectionType: layout/* SectionType.LIGHT */.bA.LIGHT,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_system_esm/* chakra.h2 */.m$.h2, {
            textStyle: "heading",
            mb: "5",
            fontSize: {
                base: "2.2rem",
                md: "2.7rem"
            },
            children: [
                "이노앤엠만의",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    as: "span",
                    color: "brand.300",
                    children: "특별함"
                })
            ]
        }),
        titleTextUnderlineDividerProps: {
            show: false
        },
        titleWrapProps: {
            mb: {
                base: "2rem",
                md: "3rem"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
            templateColumns: {
                base: "repeat(1, 1fr)",
                md: "repeat(3, 1fr)"
            },
            gap: 10,
            px: {
                md: 12
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* SpecialtyFeature */.Eu, {
                    title: "PARTNER",
                    description: "포털 사이트 뉴스 섹션에 노출되는 국내 주요 150여개 언론사와 제휴",
                    iconUrl: "/pages/business/media/sections/specialty/icon_1.png"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* SpecialtyFeature */.Eu, {
                    title: "SPECIALTY",
                    description: "전문성으로 무장한 업종별 맞춤 고품질 원고로 콘텐츠를 생성합니다.",
                    iconUrl: "/pages/business/media/sections/specialty/icon_2.png"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* SpecialtyFeature */.Eu, {
                    title: "MESSAGE",
                    description: "브랜드 소식과 정보를 효과적으로 고객에게 전달합니다.",
                    iconUrl: "/pages/business/media/sections/specialty/icon_3.png"
                })
            ]
        })
    });
};
/* harmony default export */ var specialty = (SpecialtySection);

;// CONCATENATED MODULE: ./src/views/business/media/sections/index.ts




;// CONCATENATED MODULE: ./src/pages/business/media.tsx




var MediaPage = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* BusinessPageLayout */.vr, {
        curPageIdx: 1,
        nextPageHref: "/business/marketing",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(about, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(specialty, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(process, {})
        ]
    }));
};
/* harmony default export */ var media = (MediaPage);


/***/ }),

/***/ 7812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z3": function() { return /* reexport */ business_ProcessFeature; },
  "Eu": function() { return /* reexport */ specialty_feature; }
});

// UNUSED EXPORTS: SimpleCard

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+image@1.1.8_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js
var chakra_ui_image_esm = __webpack_require__(7080);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
;// CONCATENATED MODULE: ./src/views/business/ProcessFeature.tsx



var ProcessFeature = function(param) {
    var index = param.index, title = param.title, iconUrl = param.iconUrl, contents = param.contents, // OPTIONAL
    description = param.description;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        mx: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                color: "white",
                fontSize: "1.3rem",
                fontWeight: "700",
                lineHeight: "1",
                mx: "auto",
                textAlign: "center",
                children: [
                    "STEP",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "2.8rem",
                        lineHeight: "1.2",
                        mb: "0.5rem",
                        children: index
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Circle */.Cd, {
                size: {
                    base: "9rem",
                    md: "12rem"
                },
                mx: "auto",
                mb: 6,
                bg: "white",
                color: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    flexDir: "column",
                    justify: "center",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Image */.Ee, {
                            src: iconUrl,
                            alt: title,
                            w: "90%",
                            mb: "0.2rem"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            color: "brand.900",
                            fontSize: "1.3rem",
                            fontWeight: "800",
                            mx: "auto",
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: title
                            })
                        })
                    ]
                })
            }),
            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                textAlign: "center",
                mx: "auto",
                bg: "brand.900",
                p: "0.5rem",
                color: "white",
                pos: "relative",
                borderRadius: "3xl",
                top: {
                    base: "-2.75rem",
                    md: "-3rem"
                },
                fontSize: "1.2rem",
                w: {
                    base: "63%",
                    md: "50%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    mt: "0.25rem",
                    children: description
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                textAlign: "center",
                mx: "auto",
                p: "0.75rem",
                color: "white",
                pos: "relative",
                top: {
                    base: "-2.75rem",
                    md: "-3rem"
                },
                fontSize: "1.2rem",
                w: {
                    base: "63%",
                    md: "50%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                textAlign: "center",
                mx: "auto",
                mt: "1rem",
                p: "0.5rem",
                color: "gray.300",
                pos: "relative",
                borderRadius: "20px",
                top: "-3rem",
                fontSize: {
                    base: "0.9rem",
                    md: "1.1rem"
                },
                w: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* List */.aV, {
                    spacing: 2,
                    children: contents.map(function(content) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: content
                        }, content);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var business_ProcessFeature = (ProcessFeature);

;// CONCATENATED MODULE: ./src/views/business/SimpleCard.tsx


var SimpleCard = function(param) {
    var title = param.title, description = param.description, imgUrl = param.imgUrl;
    return(/*#__PURE__*/ _jsx(Flex, {
        borderRadius: "20px",
        p: 50,
        w: "full",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Box, {
            bg: useColorModeValue("white", "gray.800"),
            maxW: "sm",
            // borderWidth="1px"
            borderRadius: "20px",
            rounded: "lg",
            shadow: "lg",
            position: "relative",
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    src: imgUrl,
                    alt: "Picture of ".concat(title),
                    roundedTop: "lg",
                    roundedBottom: "lg"
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    p: "6",
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            d: "flex",
                            alignItems: "baseline"
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            mt: "1",
                            flexDir: "column",
                            justifyContent: "space-between",
                            alignContent: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    mb: "3",
                                    fontSize: "2xl",
                                    fontWeight: "semibold",
                                    as: "h4",
                                    lineHeight: "tight",
                                    isTruncated: true,
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    fontSize: "md",
                                    fontWeight: "normal",
                                    as: "p",
                                    lineHeight: "tight",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var business_SimpleCard = ((/* unused pure expression or super */ null && (SimpleCard)));

;// CONCATENATED MODULE: ./src/views/business/specialty-feature.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CSS = {
    BORDER_COLOR: "192",
    BORDER_ALPHA: "0.5"
};
var SpecialtyFeature = function(param) {
    var title = param.title, description = param.description, iconUrl = param.iconUrl, // OPTIONAL
    wrapProps = param.wrapProps, iconProps = param.iconProps, iconWrapProps = param.iconWrapProps, textWrapProps = param.textWrapProps;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, _objectSpread({
        gap: {
            base: "5rem",
            md: "0"
        },
        mx: {
            md: "auto"
        },
        maxW: {
            md: "560px"
        }
    }, wrapProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, _objectSpread({
                mb: "2rem"
            }, iconWrapProps, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Image */.Ee, _objectSpread({
                    src: iconUrl,
                    alt: title,
                    bg: "white",
                    p: "10px",
                    maxW: "70vw",
                    border: "1px solid rgba(".concat(CSS.BORDER_COLOR, ", ").concat(CSS.BORDER_COLOR, ", ").concat(CSS.BORDER_COLOR, ", ").concat(CSS.BORDER_ALPHA, ")"),
                    borderRadius: "50%",
                    boxShadow: "lg"
                }, iconProps))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, _objectSpread({
                mx: "auto",
                color: "gray.600",
                textAlign: "center",
                w: {
                    base: "80%",
                    md: "85%"
                }
            }, textWrapProps, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    children: description
                })
            }))
        ]
    }));
};
/* harmony default export */ var specialty_feature = (SpecialtyFeature);

;// CONCATENATED MODULE: ./src/views/business/index.ts





/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [890,279,201,768,603,593,422,461,818,806,774,888,179], function() { return __webpack_exec__(7121); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);